module.exports = __webpack_public_path__ + "static/iphonex-mobile-280a31102e3399c7c1dc27fdd8b5e8ae.png";